export const HIDE_DROPDOWN = '@WS/dropdown/hide';
export const OPEN_DROPDOWN = '@WS/dropdown/open';
